export const mockAppointments = [
  {
    id: 1,
    clientName: "Elif Kaya",
    service: "Doğum Haritası",
    type: "Yazılı",
    date: "2026-03-18",
    deliveryDate: "2026-03-24",
    status: "Tamamlandı",
    color: "#10b981",
    time: null,
  },
  {
    id: 2,
    clientName: "Mert Demir",
    service: "Sinastri",
    type: "Sesli",
    date: "2026-03-22",
    deliveryDate: "2026-03-22",
    status: "Planlandı",
    color: "#a855f7",
    time: "14:00",
  },
  {
    id: 3,
    clientName: "Selin Arslan",
    service: "Yıllık Öngörü",
    type: "Yazılı",
    date: "2026-03-20",
    deliveryDate: "2026-03-27",
    status: "Ödeme Bekliyor",
    color: "#f97316",
    time: null,
  },
  {
    id: 4,
    clientName: "Ahmet Yılmaz",
    service: "Solar Return",
    type: "Sesli",
    date: "2026-03-28",
    deliveryDate: "2026-03-28",
    status: "Planlandı",
    color: "#a855f7",
    time: "11:00",
  },
  {
    id: 5,
    clientName: "Zeynep Çelik",
    service: "Rektifikasyon",
    type: "Yazılı",
    date: "2026-03-21",
    deliveryDate: "2026-03-28",
    status: "Planlandı",
    color: "#f97316",
    time: null,
  },
  {
    id: 6,
    clientName: "Caner Öztürk",
    service: "Horary",
    type: "Günlük",
    date: "2026-03-24",
    deliveryDate: "2026-03-24",
    status: "Planlandı",
    color: "#d4af37",
    time: "21:00",
  },
  {
    id: 7,
    clientName: "Ayşe Şahin",
    service: "Geçmiş Yaşam",
    type: "Yazılı",
    date: "2026-03-24",
    deliveryDate: "2026-03-31",
    status: "Ödeme Bekliyor",
    color: "#f97316",
    time: null,
  },
  {
    id: 8,
    clientName: "Burak Koç",
    service: "İlişki Analizi",
    type: "Sesli",
    date: "2026-03-29",
    deliveryDate: "2026-03-29",
    status: "Planlandı",
    color: "#a855f7",
    time: "15:00",
  },
  {
    id: 9,
    clientName: "Tarık Bulut",
    service: "Eleksiyon",
    type: "Yazılı",
    date: "2026-03-25",
    deliveryDate: "2026-04-01",
    status: "Planlandı",
    color: "#f97316",
    time: null,
  },
  {
    id: 10,
    clientName: "Pınar Güneş",
    service: "Doğum Haritası",
    type: "Yazılı",
    date: "2026-03-26",
    deliveryDate: "2026-04-02",
    status: "Yeni Başvuru",
    color: "#f97316",
    time: null,
  },
  {
    id: 11,
    clientName: "Nilüfer Aktaş",
    service: "Astrocartography",
    type: "Yazılı",
    date: "2026-03-17",
    deliveryDate: "2026-03-23",
    status: "Gecikti",
    color: "#ef4444",
    time: null,
  },
  {
    id: 12,
    clientName: "Kerem Aydın",
    service: "Sinastri",
    type: "Yazılı",
    date: "2026-03-16",
    deliveryDate: "2026-03-22",
    status: "Tamamlandı",
    color: "#10b981",
    time: null,
  },
  {
    id: 13,
    clientName: "Derya Kılıç",
    service: "Doğum Haritası",
    type: "Sesli",
    date: "2026-03-28",
    deliveryDate: "2026-03-28",
    status: "Planlandı",
    color: "#a855f7",
    time: "16:00",
  },
  {
    id: 14,
    clientName: "Hasan Çetin",
    service: "Horary",
    type: "Günlük",
    date: "2026-03-25",
    deliveryDate: "2026-03-25",
    status: "Planlandı",
    color: "#d4af37",
    time: "22:00",
  },
];

export const getDayStatus = (dateStr: string): "available" | "filling" | "full" => {
  const date = new Date(dateStr);
  const dayOfWeek = date.getDay();
  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
  const maxCapacity = isWeekend ? 5 : 2;

  const count = mockAppointments.filter(
    (a) => a.date === dateStr && a.status !== "Tamamlandı"
  ).length;

  if (count >= maxCapacity) return "full";
  if (count >= maxCapacity * 0.6) return "filling";
  return "available";
};
